function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var FrameManager = /*#__PURE__*/function () {
  function FrameManager(container) {
    _classCallCheck(this, FrameManager);

    this.container = container;
  }

  _createClass(FrameManager, [{
    key: "nextFrame",
    value: function () {
      var _nextFrame = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(timestamp) {
        var _a, container, deltaValue, delta;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                container = this.container;

                if (!(container.lastFrameTime !== undefined && timestamp < container.lastFrameTime + 1000 / container.fpsLimit)) {
                  _context.next = 5;
                  break;
                }

                container.draw(false);
                return _context.abrupt("return");

              case 5:
                (_a = container.lastFrameTime) !== null && _a !== void 0 ? _a : container.lastFrameTime = timestamp;
                deltaValue = timestamp - container.lastFrameTime, delta = {
                  value: deltaValue,
                  factor: 60 * deltaValue / 1000
                };
                container.lifeTime += delta.value;
                container.lastFrameTime = timestamp;

                if (!(deltaValue > 1000)) {
                  _context.next = 12;
                  break;
                }

                container.draw(false);
                return _context.abrupt("return");

              case 12:
                _context.next = 14;
                return container.particles.draw(delta);

              case 14:
                if (!(container.duration > 0 && container.lifeTime > container.duration)) {
                  _context.next = 17;
                  break;
                }

                container.destroy();
                return _context.abrupt("return");

              case 17:
                if (container.getAnimationStatus()) {
                  container.draw(false);
                }

                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](0);
                console.error("tsParticles error in animation loop", _context.t0);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 20]]);
      }));

      function nextFrame(_x) {
        return _nextFrame.apply(this, arguments);
      }

      return nextFrame;
    }()
  }]);

  return FrameManager;
}();